import type { Rule } from 'antd/es/form'

type BrowserEmailRuleOptions = {
  required?: boolean
}

export const buildBrowserEmailRule = ({
  required = true
}: BrowserEmailRuleOptions = {}): Rule => ({
  validator: (_rule, raw: string | undefined): Promise<void> => {
    if (typeof document === 'undefined') {
      return Promise.resolve()
    }

    const input = document.createElement('input')
    input.type = 'email'
    input.required = required
    input.value = raw ?? ''

    if (input.checkValidity()) {
      return Promise.resolve()
    }

    return Promise.reject(new Error(input.validationMessage))
  }
})
